module.exports = __webpack_public_path__ + "static/8-ead9577553520fd793416738beffb2fa.png";